export const cols = [{
	prop: 'type',
	label: '活动类型',
	width: '120',
	align: 'center'
}, {
	prop: 'code',
	label: '活动编号',
	width: '200',
	align: 'center'
}, {
	prop: 'name',
	label: '活动名称',
	width: '160',
	align: 'center'
}, {
	prop: 'discountstate',
	label: '活动状态',
	width: '180',
	align: 'center'
}, {
	prop: 'begindate',
	label: '开始时间',
	width: '180',
	align: 'center'
}, {
	prop: 'enddate',
	label: '结束时间',
	width: '160',
	align: 'center'
}, {
	prop: 'continuetime',
	label: '持续时间',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'ordercnt',
	label: '成单量',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'disaftermoney',
	label: '成单额（折后）',
	width: '150',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'totalprice',
	label: '折前额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'discountprice',
	label: '打折额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'disrate',
	label: '折扣率',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyercnt',
	label: '采购门店数',
	width: '140',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sellercnt',
	label: '供货商店铺数',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}]
